import { render } from "./ServicesSection.vue?vue&type=template&id=427da4ea&scoped=true"
import script from "./ServicesSection.vue?vue&type=script&lang=js"
export * from "./ServicesSection.vue?vue&type=script&lang=js"

import "./ServicesSection.vue?vue&type=style&index=0&id=427da4ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427da4ea"]])

export default __exports__